export const ACCESS_DENIED_MESSAGE =
  'You do not have enough permissions to view this directory. Return to root to continue.';

export const extractErrorMessage = (error: unknown, fallback: string) => {
  if (!error || typeof error !== 'object') return fallback;
  const maybeError = error as {
    data?: unknown;
    message?: string;
    error?: string;
    status?: number | string;
  };

  if (typeof maybeError.data === 'string' && maybeError.data.trim()) return maybeError.data;

  if (maybeError.data && typeof maybeError.data === 'object') {
    const data = maybeError.data as Record<string, unknown>;
    const nestedMessage =
      (typeof data.Message === 'string' && data.Message) ||
      (typeof data.message === 'string' && data.message) ||
      (typeof data.error === 'string' && data.error) ||
      (typeof data.title === 'string' && data.title);
    if (nestedMessage) return nestedMessage;
  }

  if (typeof maybeError.message === 'string' && maybeError.message.trim())
    return maybeError.message;
  if (typeof maybeError.error === 'string' && maybeError.error.trim()) return maybeError.error;

  return fallback;
};

export const isAccessDeniedError = (error: unknown) => {
  if (!error || typeof error !== 'object') return false;
  const maybeError = error as {
    status?: number | string;
    data?: unknown;
    message?: string;
    error?: string;
  };

  if (maybeError.status === 401 || maybeError.status === 403) return true;

  const message = extractErrorMessage(error, '').toLowerCase();
  return (
    message.includes('forbidden') ||
    message.includes('access denied') ||
    message.includes('insufficient permission')
  );
};
